import React from 'react';
export function Experience() {
  const securityExperiences = [{
    period: '2022 - heden',
    role: 'Coördinator Beveiliging - Schiphol Amsterdam',
    description: 'Leidinggeven aan beveiligingsteams, toezicht houden op passagiersveiligheid en samenwerking met Marechaussee en douane.'
  }];
  const pastExperiences = [{
    period: '2020 - 2021',
    role: 'Eigen initiatief – Handel in gewilde producten',
    description: 'Inkoop en verkoop van populaire consumentenproducten via online kanalen tijdens coronaperiode.'
  }, {
    period: '2019 - 2020',
    role: 'Verkoopadviseur telecom - MediaMarkt Amsterdam West',
    description: 'Adviseren van klanten, behalen van targets, begeleiden van nieuwe medewerkers.'
  }, {
    period: '2017 - 2018',
    role: 'Winkelmanager - Mobiele apparaten & reparaties',
    description: 'Dagelijks winkelbeheer, voorraadbeheer, leverancierscontact en marketing.'
  }, {
    period: '2012 - 2017',
    role: 'Eerste verkoper telecom - MediaMarkt Amsterdam Centrum',
    description: 'Verkoop, klantadvies, teambegeleiding en operationeel aanspreekpunt.'
  }, {
    period: '2012 - 2014',
    role: 'Systeembeheerder - MediaMarkt Amsterdam Centrum',
    description: 'Beheer van netwerken, kassasystemen, hardware en eerstelijns IT-support.'
  }];
  const skills = ['Leiderschap & Coördinatie', 'Klantgericht werken', 'Technische kennis', 'Stressbestendigheid', 'Meertalig (NL, EN, TR)', 'Probleemoplossend vermogen'];
  return <section className="py-16 md:py-20 border-b border-zinc-800" data-id="element-174">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <h2 className="text-2xl md:text-3xl font-light mb-8 md:mb-10" data-id="element-176">
          Beveiligingservaring
        </h2>
        <div className="grid md:grid-cols-5 gap-8 md:gap-10 mb-10 md:mb-12" data-id="element-177">
          <div className="md:col-span-3" data-id="element-178">
            <div className="mb-10 md:mb-12" data-id="element-179">
              <h3 className="text-xl font-medium mb-6 text-slate-300" data-id="element-180">
                Huidige werkzaamheden
              </h3>
              <div className="space-y-8" data-id="element-181">
                {securityExperiences.map((exp, index) => <div key={index} className="relative pl-8 border-l border-slate-700" data-id="element-182">
                    <div className="absolute -left-[5px] top-0 w-2.5 h-2.5 rounded-full bg-slate-700" data-id="element-183"></div>
                    <div className="text-sm text-slate-400 font-medium mb-2" data-id="element-184">
                      {exp.period}
                    </div>
                    <h3 className="text-lg font-medium mb-2" data-id="element-185">{exp.role}</h3>
                    <p className="text-zinc-400 text-base leading-relaxed" data-id="element-186">
                      {exp.description}
                    </p>
                  </div>)}
              </div>
            </div>
            <div data-id="element-187">
              <h3 className="text-xl font-medium mb-6 text-slate-300" data-id="element-188">
                Eerdere werkervaring
              </h3>
              <div className="space-y-8" data-id="element-189">
                {pastExperiences.map((exp, index) => <div key={index} className="relative pl-8 border-l border-zinc-800" data-id="element-190">
                    <div className="absolute -left-[4px] top-0 w-2 h-2 rounded-full bg-zinc-700" data-id="element-191"></div>
                    <div className="text-sm text-zinc-500 font-medium mb-2" data-id="element-192">
                      {exp.period}
                    </div>
                    <h3 className="text-lg font-medium mb-2 text-zinc-300" data-id="element-193">
                      {exp.role}
                    </h3>
                    <p className="text-zinc-500 text-base leading-relaxed" data-id="element-194">
                      {exp.description}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
          <div className="md:col-span-2" data-id="element-195">
            <div className="bg-zinc-900 p-6 rounded-none shadow-sm" data-id="element-196">
              <h3 className="text-xl font-medium mb-5 text-slate-300" data-id="element-197">
                Professionele vaardigheden
              </h3>
              <ul className="space-y-3 text-base" data-id="element-198">
                {skills.map((skill, index) => <li key={index} className="flex items-center gap-3" data-id="element-199">
                    <span className="w-1.5 h-1.5 bg-slate-700 rounded-full" data-id="element-200"></span>
                    <span data-id="element-201">{skill}</span>
                  </li>)}
              </ul>
              <div className="mt-8 p-5 bg-black rounded-none border-l border-zinc-700" data-id="element-202">
                <div className="text-base italic text-zinc-300 leading-relaxed" data-id="element-203">
                  "Met mijn brede achtergrond in beveiliging, retail en IT bied
                  ik een unieke combinatie van technische kennis,
                  leiderschapsvaardigheden en klantgerichtheid."
                </div>
                <div className="mt-3 text-right text-sm text-zinc-400" data-id="element-204">
                  — Ahmet Uzun
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}